import { useState } from 'react';
import {
  PreviewBranchReceipt,
  PreviewReceiptOnboard,
  PreviewWhatsappBranch,
  PreviewWhatsappOnboard
} from '@images';

import Button from '@components/button/Button';
import Modal from '@layouts/modal/Modal';

interface PreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  flow: 'orgOnboard' | 'branch' | 'individualOnboard';
}

const PreviewModal = ({ isOpen, onClose, flow }: PreviewModalProps) => {
  const [stepper, setStepper] = useState<number>(1);
  const renderFirstPreview = () => {
    let content;
    switch (flow) {
      case 'orgOnboard':
        content = <PreviewWhatsappOnboard />;
        break;
      case 'branch':
        content = <PreviewWhatsappBranch />;
        break;
      case 'individualOnboard':
        content = <PreviewWhatsappOnboard />;
        break;
      default:
        content = null;
    }

    return <div>{content}</div>;
  };
  const renderSecondPreview = () => {
    let content;
    switch (flow) {
      case 'orgOnboard':
        content = <PreviewReceiptOnboard />;
        break;
      case 'branch':
        content = <PreviewBranchReceipt />;
        break;
      case 'individualOnboard':
        content = <PreviewReceiptOnboard />;
        break;
      default:
        content = null;
    }

    return <div>{content}</div>;
  };

  return (
    <Modal
      isOpen={isOpen}
      onCancel={onClose}
      className="bg-white p-6"
      isClickOutsideRequired
      isCloseIconRequired
    >
      <div className="text-lg font-semibold text-content">Preview</div>
      {stepper === 1 && renderFirstPreview()}
      {stepper === 2 && renderSecondPreview()}
      <div className="mt-2.5 flex w-full justify-center gap-2">
        <div
          className={`size-2.5 rounded-full ${
            stepper === 1 ? 'bg-primary' : 'bg-grey'
          }`}
        />
        <div
          className={`size-2.5 rounded-full ${
            stepper === 2 ? 'bg-primary' : 'bg-grey'
          }`}
        />
      </div>
      <div className="mt-4 flex justify-end">
        {stepper === 1 && (
          <Button
            label="Next"
            className="w-37.5"
            handleClick={() => setStepper(2)}
          />
        )}
        {stepper === 2 && (
          <div className="flex items-center gap-6">
            <div
              role="presentation"
              className="cursor-pointer text-base font-medium"
              onClick={() => setStepper(1)}
            >
              Back
            </div>
            <Button label="Got It" className="w-37.5" handleClick={onClose} />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PreviewModal;
